module.exports = __webpack_public_path__ + "static/media/sell_change_request_7.ab49399c.png";